import { render, staticRenderFns } from "./methodConfigComponent.vue?vue&type=template&id=bfe10140&scoped=true"
import script from "./methodConfigComponent.vue?vue&type=script&lang=js"
export * from "./methodConfigComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe10140",
  null
  
)

export default component.exports